import { getNamespacedLogger } from '../components/Logger';
import { NAMESPACE } from './app.constants';
var logger = getNamespacedLogger(NAMESPACE);
export default logger;
//# sourceMappingURL=app.logger.js.map